<template>
  <div ref="root" class="listing-type-select" :class="{ 'is-open': open }">
    <button
      type="button"
      class="listing-type-select__trigger"
      :class="{ 'is-on': selected.length }"
      :aria-expanded="open"
      @click="open = !open"
    >
      <SvgIcon name="home" :size="15" />
      <span class="listing-type-select__label">{{ label }}</span>
      <SvgIcon name="chevron" :size="13" class="listing-type-select__chevron" />
    </button>
    <div v-if="open" class="listing-type-select__menu">
      <label
        v-for="type in housingTypes"
        :key="type.slug"
        class="listing-type-select__option"
        :class="{ 'is-selected': selected.includes(type.slug) }"
      >
        <input type="checkbox" :checked="selected.includes(type.slug)" @change="toggle(type.slug)" />
        <span class="listing-type-select__box">
          <SvgIcon v-if="selected.includes(type.slug)" name="check" :size="12" />
        </span>
        <span class="listing-type-select__text">{{ type.label }}</span>
      </label>
      <button
        v-if="selected.length"
        type="button"
        class="listing-type-select__clear"
        @click="emit('update:modelValue', [])"
      >
        <SvgIcon name="x" :size="12" />{{ t('listing-search.type-select.clear') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { t } from '../lib/i18n';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import SvgIcon from './SvgIcon.vue';

const props = defineProps({
  housingTypes: { type: Array, required: true },
  modelValue: { type: Array, required: true }
});

const emit = defineEmits(['update:modelValue']);

const open = ref(false);
const root = ref(null);

const selected = computed(() => props.modelValue);

const label = computed(() => {
  if (!selected.value.length) return t('listing-search.type-select.all');
  if (selected.value.length === 1) {
    const match = props.housingTypes.find((type) => type.slug === selected.value[0]);
    return match ? match.label : selected.value[0];
  }
  return t('listing-search.housing.types-count', { count: selected.value.length });
});

const toggle = (slug) => {
  const next = selected.value.includes(slug)
    ? selected.value.filter((item) => item !== slug)
    : [...selected.value, slug];
  emit('update:modelValue', next);
};

const onDocMousedown = (event) => {
  if (root.value && !root.value.contains(event.target)) open.value = false;
};

// Capture phase: the surrounding popover stops mousedown propagation, which
// would otherwise keep this menu open on clicks elsewhere inside the popover.
onMounted(() => document.addEventListener('mousedown', onDocMousedown, true));
onBeforeUnmount(() => document.removeEventListener('mousedown', onDocMousedown, true));
</script>
